import Grid from "@mui/material/Grid2";

import DatePicker from "~/components/common/forms/DatePicker";;
import { DailyRRule } from "@caredna-marlin/utils/client/availability";
import { datef } from "@caredna-marlin/utils/dates";
import Help from "~/components/common/Help";

type RepeatDailyFormProps = {
  disabled?: boolean,
  rrule: DailyRRule;
  startLocked: boolean;
  setRRule: (rrule: DailyRRule) => void;
  toHelpText?: string;
};

const RepeatDailyForm = ({ disabled, rrule, setRRule, startLocked, toHelpText }: RepeatDailyFormProps) => {
  return <>
    <Grid size={3}><span>From</span></Grid>
    <Grid size={9} sx={{ pl: startLocked ? "6px" : undefined }}>
      {startLocked ? <>
        {datef(rrule.dtstart, "MM/dd/yyyy")} <Help text="Cannot edit the start date in the past" />
      </> : <DatePicker
        disablePast
        value={rrule.dtstart}
        disabled={disabled}
        sx={{ width: "100%" }}
        onChange={(dtstart) => dtstart?.getTime() && setRRule({...rrule, dtstart})}
      />}
    </Grid>
    <Grid size={3}><span>To {toHelpText && <Help text={toHelpText} />}</span></Grid>
    <Grid size={9}>
      <DatePicker
        disablePast
        value={rrule.until}
        disabled={disabled}
        sx={{ width: "100%" }}
        onChange={(until) => until?.getTime() && setRRule({...rrule, until})}
      />
    </Grid>
  </>
}

export default RepeatDailyForm;
